import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link } from 'react-router-dom';
export const Partner = () => {
    var setting = {
        arrows:         false,
        infinite:       false,
        dots:true,
        slidesToShow:   4,
        slidesToScroll: 4,
        className:'partner-slider',
        centerMode:false,
        centerPadding:'0px',   
    }
    return (
        <section className="partners">
            <div className="container container1440">
                <div className="partner">
                    <div className="title">
                        <h3>Partners</h3>
                        <h2>Who are our corporate</h2>
                    </div>
                    <div className="partner-slide">
                       <Slider {...setting}>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                    <img src={require('../../images/GMi68-international-nomad-cambodia-partner-01.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-02.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-03.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-04.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-02.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-03.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-04.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-02.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            <div className="slick-slideshow__slide">
                                <Link to="/">
                                    <div className="list">
                                        <img src={require('../../images/GMi68-international-nomad-cambodia-partner-03.jpg')} alt="" />
                                    </div>
                                </Link>
                            </div>
                            
                        </Slider>
                    </div>
                </div>
            </div>
        </section>
    )
}